import { render, staticRenderFns } from "./SetNewPasswordForm.vue?vue&type=template&id=6784224b&lang=pug&"
import script from "./SetNewPasswordForm.vue?vue&type=script&lang=js&"
export * from "./SetNewPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports